/**
 * Who signs the performance report (Leistungsnachweis) for the contractor. Configured on customers and
 * projects; `null` means "not configured" (project falls back to customer, customer falls back to Manager).
 * Values must match `TimesheetSignees` in the backend.
 */
export enum TimesheetSignee {
    Manager = 'manager',
    Employee = 'employee',
}

export const timesheetSigneeLabelKeys: Record<TimesheetSignee, string> = {
    [TimesheetSignee.Manager]: 'timesheetSignee_manager_option',
    [TimesheetSignee.Employee]: 'timesheetSignee_employee_option',
};

/** Backend error `TimesheetSignatureMissing`; each error field name carries the affected user id. */
export const TIMESHEET_SIGNATURE_MISSING_ERROR_CODE = 11051;
